/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2026 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export default class AJOConstants {
  static CONTENT_TYPES = {
    JSON: 'https://ns.adobe.com/personalization/json-content-item',
    HTML: 'https://ns.adobe.com/personalization/html-content-item',
  };

  static CONTEXT_KEYS = {
    BETA_ENABLED: '_adobe_corpnew.user.betaEnabled',
    CUSTOMER_LOCALE: '_adobe_corpnew.user.customerLocale',
    DROPIN_ID: '_adobe_corpnew.event.dropinID',
    FEATURE_SET_TYPE: '_adobe_corpnew.user.featureSetType',
    INVOCATION_CONTEXT: '_adobe_corpnew.event.invocationContext',
    UPSELL_TYPE: '_adobe_corpnew.event.upsellType',
    USER_COUNTRY: '_adobe_corpnew.user.country',
  };
}
